import ContactService from "../../api/contactService";
import {RootState} from "../index";
import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import i18n from "../../config/i18n";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import CfgAttributeService from "../../api/cfgAttributeService";
import {CfgAttributesNames} from "../../util/constants";
import {setApplicationError} from "../app/Slice";


export const getContacts =
    createAsyncThunk(`${SliceNames.CONTACT}/getContacts`,
        async (req: { page: number, firstRender: boolean }, thunkAPI) => {
            try {
                const res = await ContactService.fetchContacts(req.page, 10)
                const oldContacts = (thunkAPI.getState() as RootState).contactReducer.items.data
                res.data.data = req.firstRender ? res.data.data : [...oldContacts, ...res.data.data]
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const deleteContact =
    createAsyncThunk(`${SliceNames.CONTACT}/deleteContact`,
        async (req: { contactId: string, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                await ContactService.deleteContact(req.contactId)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return req.contactId
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getContactUsContent =
    createAsyncThunk(`${SliceNames.CONTACT}/getContactUsContent`,
        async (_, thunkAPI) => {
            try {
                const res = await CfgAttributeService.fetchAttributeValue(CfgAttributesNames.CONTACT_US)
                return res.data
            } catch (e: any) {
                thunkAPI.dispatch(
                    setApplicationError({
                        isError: true,
                        statusCode: undefined
                    }))
                return thunkAPI.rejectWithValue(e)
            }
        })